import { render, staticRenderFns } from "./FileLoader127.vue?vue&type=template&id=9707e690&scoped=true&"
import script from "./FileLoader127.vue?vue&type=script&lang=js&"
export * from "./FileLoader127.vue?vue&type=script&lang=js&"
import style0 from "./FileLoader127.vue?vue&type=style&index=0&id=9707e690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9707e690",
  null
  
)

export default component.exports